import { UseFormReturn } from 'react-hook-form'

import { BorrowOverviewPanel } from '../components/BorrowOverviewPanel'
import { PositionOverview } from '../types'
import { TokenWithBalance, TokenWithValue } from '@/domain/common/types'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { RiskAcknowledgementInfo } from '@/features/sparklend/common/utils/liquidation-risk-warning/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { SparkRewardCampaign } from '@/ui/molecules/spark-reward-pill/SparkRewardPill'
import { RiskAcknowledgement } from '@/ui/organisms/risk-acknowledgement/RiskAcknowledgement'

export interface BorrowViewProps {
  dialogTitle: string
  selectableAssets: TokenWithBalance[]
  borrowAsset: TokenWithValue
  assetsFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  actionsViewState: ActionsViewState
  currentPositionOverview: PositionOverview
  updatedPositionOverview: PositionOverview | undefined
  riskAcknowledgement: RiskAcknowledgementInfo
  relatedCampaigns: SparkRewardCampaign[]
}

export function BorrowView({
  dialogTitle,
  selectableAssets,
  assetsFields,
  form,
  actionsViewState,
  borrowAsset,
  currentPositionOverview,
  updatedPositionOverview,
  riskAcknowledgement,
  relatedCampaigns,
}: BorrowViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>{dialogTitle}</DialogTitle>

      <FormAndOverviewWrapper>
        <DialogForm form={form} assetsFields={assetsFields} selectorAssets={selectableAssets} />
        <BorrowOverviewPanel
          borrowAsset={borrowAsset.token}
          currentPositionOverview={currentPositionOverview}
          updatedPositionOverview={updatedPositionOverview}
          relatedCampaigns={relatedCampaigns}
        />
      </FormAndOverviewWrapper>

      {riskAcknowledgement.warning && (
        <RiskAcknowledgement
          onStatusChange={riskAcknowledgement.onStatusChange}
          warning={riskAcknowledgement.warning}
        />
      )}

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
